import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Button, SmileIcon, useUserInfoContext } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';

import { Mediator } from '@spotahome/soyuz-mediator';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';
import { EXTERNAL_REDIRECTION_LOGIN_MODAL } from '@spotahome/marketplace-common/src/channels';

import './ListingDoubts.scss';
import { ACTION_OPEN_DOUBTS_MODAL } from '../../constants';

import ListingDoubtsModal from './ListingDoubtsModal';

const ListingDoubts = ({ cityId, listingId, countryCode }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isUserLogged } = useUserInfoContext();

  const openListingDoubtsModal = () => {
    setIsModalOpen(true);
    SoyuzAnalytics.sendGA4Event('open', { section: 'listing-doubts-modal' });
  };

  const handleModalClose = () => setIsModalOpen(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    if (
      isUserLogged &&
      queryParams.get('action') === ACTION_OPEN_DOUBTS_MODAL
    ) {
      openListingDoubtsModal();
      queryParams.delete('action');
      window.history.replaceState(
        {},
        '',
        `${window.location.pathname}?${queryParams.toString()}`
      );
    }
  }, [isUserLogged]);

  const withUserLogged = (cb, actionParam) => () => {
    if (!isUserLogged) {
      const redirectUrl = window.location.origin + window.location.pathname;
      const queryParams = new URLSearchParams(window.location.search);
      queryParams.set('action', actionParam);
      Mediator.publish(EXTERNAL_REDIRECTION_LOGIN_MODAL, {
        initialAction: 'signup',
        renderTitle: action => trans(`${action}.modal.title`),
        renderSubtitle: action => trans(`${action}.modal.subtitle`),
        url: `${redirectUrl}?${queryParams.toString()}`
      });

      SoyuzAnalytics.sendGA4Event('open', {
        section: `${actionParam}-modal-sign-up`
      });
      return;
    }

    cb();
  };

  const handleOnSubmitDoubtsClick = withUserLogged(
    openListingDoubtsModal,
    ACTION_OPEN_DOUBTS_MODAL
  );

  return (
    <>
      <ListingDoubtsModal
        handleClose={handleModalClose}
        isOpen={isModalOpen}
        listingId={listingId}
        cityId={cityId}
        countryCode={countryCode}
      />

      <div className="listing-doubts">
        <div className="listing-doubts__info-wrapper">
          <div className="listing-doubts__smile-icon">
            <SmileIcon />
          </div>
          <div>
            <div className="listing-doubts__title">
              {trans('listing.doubts.title')}
            </div>
            <div>{trans('listing.doubts.text')}</div>
          </div>
        </div>
        <div>
          <Button
            className="listing-doubts__cta"
            color="interaction"
            onClick={handleOnSubmitDoubtsClick}
          >
            {trans('listing.doubts.cta')}
          </Button>
        </div>
      </div>
    </>
  );
};

ListingDoubts.propTypes = {
  listingId: PropTypes.string.isRequired,
  cityId: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired
};

export default ListingDoubts;
